

























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import SidebarItem from './SidebarItem.vue'
import variables from '@/styles/_variables.scss'
import { getSidebarStatus, setSidebarStatus } from '@/utils/cookies'
import Cookies from 'js-cookie'
@Component({
  name: 'SideBar',
  components: {
    SidebarItem
  }
})
export default class extends Vue {
  private restKey: number = 0
  private deviceType: '1'
  get name() {
    return (UserModule.userInfo as any).name
      ? (UserModule.userInfo as any).name
      : JSON.parse(Cookies.get('user_info') as any).name
  }
  get defOpen() {
    // const urlArr = this.$route.path.split('/')
    // const openStr = urlArr.length > 2 ? `/${urlArr[1]}` : '/'
    let path = ['/']
    this.routes.forEach((n: any, i: number) => {
      if (n.meta.roles && n.meta.roles[0] === this.roles[0]) {
        path.splice(0, 1, n.path)
      }
    })
    return path
  }

  created() {
    this.deviceType = UserModule.deviceType
  }

  changeMenu() {
    // 切换设备类型 (0:手机, 1:PC)
    this.deviceType = UserModule.deviceType
  const newDeviceType = this.deviceType === 1 ? 0 : 1;

  // 更新本地状态
  this.deviceType = newDeviceType;

  // 更新Vuex中的设备类型状态
  UserModule.SET_DEVICETYPE(newDeviceType);

  // 更新Cookies中的设备类型
  Cookies.set('deviceType', newDeviceType);

  // 根据新设备类型跳转到对应路由
  if (newDeviceType === 0) {
    // 切换到手机版 - 跳转到手机版首页
    if (this.$route.path !== '/phone') {
      this.$router.push('/phone');
    }
  } else {
    // 切换到PC版 - 根据用户权限跳转到不同首页
    if (UserModule.username === 'admin' || UserModule.username === 'zhangsan') {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    } else {
      if (this.$route.path !== '/other') {
        this.$router.push('/other');
      }
    }
  }

  // 强制刷新菜单显示
  this.$forceUpdate();
  // this.routes();
  }

  get defAct() {
    let path = this.$route.path
    return path
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get roles() {
    return UserModule.roles
  }

  get routes() {
    let routes = JSON.parse(
      JSON.stringify([...(this.$router as any).options.routes])
    )
    console.log('-=-=routes=-=-=', routes)
    console.log('-=-=routes=-=-=', this.roles[0])
    // console.log("设备信息",UserModule.deviceType)
    this.deviceType = UserModule.deviceType
    let menuList = []
    let menu = routes.find(item => item.path === '/')
    let menuTO = routes.find(item => item.path === '/other')
    let menuTOPhone = routes.find(item => item.path === '/phone')
    if (this.deviceType == '0') {
      menuList = menuTOPhone.children
    } else if (menu && UserModule.username == 'admin' || UserModule.username == 'zhangsan') {
      menuList = menu.children
    } else {
      menuList = menuTO.children
    }
    console.log('-=-=routes=-wwww=-=', routes)
    return menuList
  }

  get variables() {
    return variables
  }

  get isCollapse() {
    return !this.sidebar.opened
  }
  private async logout() {
    this.$store.dispatch('LogOut').then(() => {
      // location.href = '/'
      this.$router.replace({ path: '/login' })
    })
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }
}
